module.exports = {"140828100":"瑶峰镇","140828101":"庙前镇","140828102":"裴介镇","140828103":"水头镇","140828104":"埝掌镇","140828105":"泗交镇","140828106":"禹王镇","140828200":"尉郭乡","140828202":"胡张乡","140828203":"南大里乡","140828204":"祁家河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140828.json
// module id = 429
// module chunks = 0